<template>
    <Modal :open="displayModal" @close="displayModal = false">
        <div class="w-full bg-white shadow-lg rounded-none md:rounded-lg p-6">

            <div class="w-full relative">
                <h2 class="font-semibold text-gray-900 text-2xl leading-tight border-b-2 border-gray-200 pb-4">Approve Stream Sale</h2>
                <button class="text-grey-darkest font-bold rounded absolute top-0 right-0 outline-none text-xl absolute" @click="displayModal = false">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="mt-4" v-if="data !== null">

                <p>Approving this video sale will allow the stringer to see the sale within their panel.</p>

                <p class="my-4">
                    <table>
                        <tr>
                            <td class="font-semibold pr-5">Purchasing Network</td>
                            <td>{{ data.network.name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold pr-5">Purchasing User</td>
                            <td>{{ data.purchaser.name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold pr-5">Stream Info</td>
                            <td>{{ data.description }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold pr-5">Purchase Price</td>
                            <td>${{ data.price }}</td>
                        </tr>
                    </table>
                </p>

                <div class="mb-4">
                    <label for="name" class="col-sm-5 col-form-label text-left d-flex align-items-center fw-600">Stringer</label>
                    <div class="col-sm-7">
                        <v-select :debounce="250" @search="getOptions" :options="userCollection" v-model="user" placeholder="Search for a user..." label="name"></v-select>
                    </div>
                </div>

                <div class="mb-4">
                    <label for="name" class="col-sm-5 col-form-label text-left d-flex align-items-center fw-600">Sale Price</label>
                    <div class="flex flex-wrap items-stretch w-full mb-4 relative">
                        <div class="flex -mr-px">
                            <span class="flex items-center leading-normal bg-gray-200 rounded rounded-r-none border-2 border-r-0 border-grey-light px-3 whitespace-no-wrap text-grey-darker text-sm font-bold">$</span>
                        </div>				
                        <input type="text" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-2 rounded rounded-l-none h-10 border-grey-light px-3 relative bg-grey-lighter focus:outline-none focus:border-gray-darkest focus:bg-white" v-model="data.price">
                    </div>
                </div>

                <div class="mb-4">
                    <label for="name" class="col-sm-5 col-form-label text-left d-flex align-items-center fw-600">Stringer Amount</label>
                    <div class="flex flex-wrap items-stretch w-full mb-4 relative">
                        <div class="flex -mr-px">
                            <span class="flex items-center leading-normal bg-gray-200 rounded rounded-r-none border-2 border-r-0 border-grey-light px-3 whitespace-no-wrap text-grey-darker text-sm font-bold">$</span>
                        </div>				
                        <input type="text" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-2 rounded rounded-l-none h-10 border-grey-light px-3 relative bg-grey-lighter focus:outline-none focus:border-gray-darkest focus:bg-white" v-model="stringerAmount">
                    </div>
                </div>

                <div class="mb-4">
                    <label for="server_id" class="col-sm-5 col-form-label text-left d-flex align-items-center fw-600">Invoice Number</label>
                    <div class="col-sm-7">
                        <input type="text" class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="name" v-model="invoiceNumber">
                    </div>
                </div>

                <small>Notice: If you specify a value other than the default in the stringer percent box, it will only be applied to this video.</small>

            </div>

             <!-- footer -->
            <div class="mt-10 clearfix">
                <button v-on:click="displayModal = false" class="px-4 py-2 text-gray-800 font-semibold bg-white hover:bg-gray-100 border rounded focus:outline-none focus:shadow-outline float-left">
                    Cancel
                </button>
                <div class="float-right">
                    <button v-on:click="deleteSale" class="px-4 py-2 text-white font-semibold bg-red-600 hover:bg-red-700 border border-transparent rounded focus:outline-none focus:shadow-outline mr-2 float-left">
                        Delete Sale
                    </button>
                    <button v-on:click="acceptSale" class="px-4 py-2 text-white font-semibold bg-blue-700 hover:bg-blue-800 border border-transparent rounded focus:outline-none focus:shadow-outline float-right">
                        Approve Sale
                    </button>
                </div>
            </div>

        </div>
    </Modal>


</template>

<script>
    import { EventBus } from '@/utils/events'
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex'

    import Modal from '@/components/Modal'

    export default {
        data() {
            return {
                displayModal: false,
                data: null,
                user: {},
                stringerAmount: 0,
                invoiceNumber: null,
                percent: 0,
                userCollection: [],
            }
        },

        components: {
            Modal
        },

        mounted() {
            this.$nextTick(function () {
                EventBus.$on('admin-approve-stream-sale-open-modal', this.open);
            }.bind(this));

        },

        destroyed() {
            EventBus.$off('admin-approve-stream-sale-open-modal', this.open);
        },

        methods: {
             ...mapGetters([
                'getAuthorizationHeader',
            ]),

            close() {
                // this.players[0].destroy();
                this.user = {}
            },

            open(data) {
                this.displayModal = true
                this.data = data

                // get users percent
                // this.calculateStringerAmount();
            },

            acceptSale() {

                if(this.user.id == undefined) {
                    this.$swal(
                        'Whoops!',
                        'You need to assign this sale to a user.',
                        'error'
                    )
                    return;
                }

                var data = {
                    id: this.data.id,
                    price: this.data.price,
                    stringer_cut: this.stringerAmount,
                    invoiceNumber: this.invoiceNumber,
                    user_id: this.user.id
                }

                this.data.status = 'approved';
                var _this = this
                this.$http.post(Config.apiPath + "/api/v2/admin/stream_sales/approve", data, this.getAuthorizationHeader()).then((response) => {
                    if(response.status == 200) {
                        this.$swal(
                            'All good!',
                            'The sale was successfully approved.',
                            'success'
                        )
                        _this.displayModal = false
                        EventBus.$emit('admin-approve-sale-refresh-data');
                    }
                });
                

            },

            deleteSale() {

                var _this = this;

                this.$swal({
                    title: "Verify",
                    text: "Are you sure you want to remove the sale? This action is not reversible.",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it.'
                })
                .then((result) => {
                    if (result.value) {
                        var _this = this
                        this.$http.post(Config.apiPath + "/api/v2/admin/stream_sales/delete", {
                            id: _this.data.id
                        }, this.getAuthorizationHeader()).then((response) => {
                            if(response.status == 200) {

                                _this.$swal(
                                    'All good!',
                                    'The sale was successfully deleted.',
                                    'success'
                                )

                                EventBus.$emit('admin-approve-sale-refresh-data');
                                _this.displayModal = false

                            }
                        });
                    }
                });

            },

            getUserDetails(owner_id) {

                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/users/" + owner_id, this.getAuthorizationHeader()).then((response) => {
                    _this.user = response.data

                    if(response.data.settings !== null) {
                        _this.percent = response.data.settings.percent
                    }
                    
                });

            },

            modalClosed() {
                this.data = null
            },

            getOptions(search, loading) {
                loading(true)
                var data = {
                    name: search,
                }
                this.$http.post(Config.apiPath + '/api/v2/admin/users/search/stringers', data, this.getAuthorizationHeader())
                    .then(response => {
                        this.userCollection = response.data;
                        loading(false)
                    })
            },

        },
        
    }
</script>

<style>
    .video-preview {
        text-align: center;
        color: #495057;
    }
</style>